import { JsonViewIcons } from 'BreetAssets';
import { selectModals, useAppSelector } from 'BreetRedux';
import { type ChangeEvent, useCallback, useEffect, useMemo, useRef, useState } from 'react';

import JsonNode from './JsonNode';
import { type JsonValue } from './JsonViewer.helpers';

const ExpandedModal = () => {
	const [copied, setCopied] = useState(false);

	const modals = useAppSelector(selectModals);
	const selectedModal = modals.find((modalItem) => modalItem.id === 'jsonViewer');

	const dataProps = selectedModal?.metadata as { data: string } | undefined;

	const data = useMemo(() => (dataProps?.data ? JSON.parse(dataProps.data) : {}) as JsonValue, [dataProps?.data]);

	const handleCopy = useCallback(async () => {
		await navigator.clipboard.writeText(JSON.stringify(data, null, 2));
		setCopied(true);
		setTimeout(() => setCopied(false), 1500);
	}, [data]);

	const [search, setSearch] = useState('');
	const searchRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		searchRef.current?.focus();
	}, []);

	useEffect(() => {
		const prev = document.body.style.overflow;
		document.body.style.overflow = 'hidden';
		return () => {
			document.body.style.overflow = prev;
		};
	}, []);

	const handleSearch = useCallback((e: ChangeEvent<HTMLInputElement>) => {
		setSearch(e.target.value);
	}, []);

	return (
		<div className='jv-overlay bg-primary-500'>
			<div className='jv-modal bg-primary-500'>
				<div className='jv-modal-header'>
					<div className='jv-modal-actions'>
						<input
							ref={searchRef}
							className='jv-search'
							type='text'
							placeholder='search keys & values...'
							value={search}
							onChange={handleSearch}
							aria-label='Search JSON'
						/>
						<div className='jv-toolbar'>
							{copied && <span className='jv-toast'>copied!</span>}
							<button
								className='jv-btn'
								onClick={handleCopy}
								title='Copy JSON'
							>
								<JsonViewIcons variant='copy' />
							</button>
						</div>
					</div>
				</div>

				<div className='jv-modal-body scrollbar'>
					<pre className='jv-pre'>
						<span className='jv-line'>
							<JsonNode
								value={data}
								highlight={search.trim()}
							/>
						</span>
					</pre>
				</div>
			</div>
		</div>
	);
};

export default ExpandedModal;
